<template>
  <div class="p-company-settings-security">
    <h2>{{ $t('companySettings.security.title') }}</h2>
    <hr class="mb-lg" />
    <template>
      <div class="flex justify-between">
        <div class="flex flex-col">
          <h3>{{ $t('companySettings.security.mfa.subtitle', {company_name: company.name}) }}</h3>
          <p class='mb-0.5'>{{ $t('companySettings.security.mfa.info1', {company_name: company.name}) }}</p>
          <p>{{ $t('companySettings.security.mfa.info2') }}</p>
        </div>
        <div class="self-center">
          <div class="flex items-center">
            <VCheckbox
              type="checkbox"
              subtype="toggle"
              data-ec="security"
              data-et="super_admin_2FA_toggle"
              @input="handleUpdatingMfaStatus($event)"
              :checked="mfaEnabled"
            />
            <b class="min-w-toggle ml-base justify-self-center">
              {{ mfaEnabled ? $t('companySettings.security.mfa.enabled') : $t('companySettings.security.mfa.disabled')}}
            </b>
          </div>
        </div>
      </div>
      <hr class="mb-lg" />
    </template>
    <VPlanPermissionBlocker
      v-if="!hasFeature"
      :planSize="$t('companyPermissionWarning.largePlan')"
      blockedFeature="companyPermissionWarning.allowlist"
      ec="security" />
    <template v-else>
      <ElButton
          type="primary"
          class="float-right"
          icon="el-icon-plus"
          @click="openNewModal"
          data-ec="settings_security"
          data-et="open_add_ip_modal_button">
        <span>{{ $t('ip.add') }}</span>
      </ElButton>
      <h3>{{ $t('ip.ipAllowlisting') }}</h3>
      <p>{{ $t('ip.description') }}</p>

      <ElTable
        class="p-company-settings-security__table-margin"
        v-loading="!hasLoaded"
        :data="results"
        :empty-text="$t('ip.noIps')">
        <ElTableColumn :label="$t('ip.columns.label')" prop="alias" />
        <ElTableColumn :label="$t('ip.columns.ip')" prop="ip_start" />
        <ElTableColumn :label="$t('ip.columns.createdAt')">
          <template slot-scope="scope">
            {{scope.row.created | formatDate('calendar')}}
          </template>
        </ElTableColumn>
        <ElTableColumn
          :label="$t('ip.columns.actions')"
          align="right"
          width="120">
          <template slot-scope="scope">
            <ElTooltip class="item" effect="dark" :content="$t('functional.delete')" placement="top-end">
              <ElButton
                circle
                data-ec="settings_security"
                data-et="open_delete_ip_modal_button"
                type="outlineDanger"
                size="small"
                icon="el-icon-delete"
                @click="openDeleteModal(scope.row)">
              </ElButton>
            </ElTooltip>
          </template>
        </ElTableColumn>
      </ElTable>

      <p class='mb-0.5'>{{ $t('ip.allowlistingStatus') }}<b>{{ allowlistingEnabledMessage }}</b></p>
      <p>{{ $t('ip.contactSupport') }} {{ $t('ip.contactCustomerSuccess') }}</p>
    </template>

    <NewModal :show="newModalVisible" @close="newModalVisible = false;" />
    <DeleteIpModal :show="deleteModalVisible" :ip="selectedIp" @close="deleteModalVisible = false;" />

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import VPlanPermissionBlocker from '@/views/components/PlanPermissionBlocker.vue';
import NewModal from '@/views/modals/ip/new.vue';
import DeleteIpModal from '@/views/modals/ip/delete.vue';
import VCheckbox from '@/components/deprecated/atoms/Checkbox.vue';
import { logAmplitudeEvent } from '@/utils/analytics';

export default {
  name: 'SecurityView',
  components: {
    VPlanPermissionBlocker,
    NewModal,
    DeleteIpModal,
    VCheckbox,
},
  data() {
    return {
      newModalVisible: false,
      deleteModalVisible: false,
      selectedIp: {},
    };
  },
  created() {
    this.loadData();
  },
  computed: {
    ...mapGetters({
      results: 'ip/pagedResults',
      hasLoaded: 'ip/hasLoaded',
      mfaEnabled: 'company/mfaEnabled',
      featureEnabled: 'featureFlags/featureEnabled',
      company: 'company/company',
    }),
    hasFeature() {
      return this.$store.getters['plan/permissions'].allowlist;
    },
    allowlistingEnabledMessage() {
      return this.$store.getters['company/company'].ip_allowlisting_enabled ? this.$t('functional.enabled') : this.$t('functional.disabled');
    },
  },
  mounted() {
    this.$store.dispatch('company/GET');
  },
  methods: {
    ...mapActions({
      updateMfaStatus: 'company/UPDATE_MFA_STATUS',
    }),
    handleUpdatingMfaStatus(value) {
      this.updateMfaStatus(value).then(() => {
        this.$bus.$emit('renderGlobalMessage', ({ message: this.$t('mfa.companySettingsUpdated'), icon: 'check', type: 'success' }));
        logAmplitudeEvent('company_settings_security_tab--2fa-status-update-success');
      }).catch(() => {
        logAmplitudeEvent('company_settings_security_tab--2fa-status-update-failed');
      });
    },
    loadData() {
      if (!this.hasFeature) return;
      this.$store.dispatch('ip/PAGINATE', { page: 1 });
    },
    openNewModal() {
      this.newModalVisible = true;
    },
    openDeleteModal(item) {
      this.selectedIp = item;
      this.deleteModalVisible = true;
    },
  },
};
</script>

<style scoped>
.p-company-settings-security__table-margin {
  margin-bottom: var(--spacing-base);
}
</style>
